/**
 * Grid instances
 * Apart from these constants, it can also be a string (embedded-report, or report) which is the number of the report converted to string
 **/
export const GRID_BP_OEM_OVERVIEW:string = 'gridBPOEMOverview';
export const GRID_BP_CATALOG_OVERVIEW:string = 'gridBPCatalogOverview';
export const GRID_BP_CONTACTS:string = 'gridBPContacts';
export const GRID_BP_DOCUMENTS:string = 'gridBPDocuments';
export const GRID_BP_LOCATIONS:string = 'gridBPLocations';
export const GRID_BP_MAILS:string = 'gridBPMails';
export const GRID_BP_TICKETS:string = 'gridBPTickets';
export const GRID_ORDER_ENTRY_DOCUMENTS:string = 'gridOrderEntryDocuments';
export const GRID_ORDER_ENTRY_CHARGES:string = 'gridOrderEntryCharges';
export const GRID_ORDER_ASSET:string = 'gridOrderAsset';
export const GRID_PAYMENT_LIST_INVOICES:string = 'gridPaymentListInvoices';
export const GRID_PAYMENT_LIST_MATCHES:string = 'gridPaymentListMatches';
export const GRID_UPLOAD_STEP_THREE:string = 'gridUploadStepThree';
export const GRID_FAQ_DOCUMENTS:string = 'gridFaqDocuments';